export class PrivateLinkCheckResult {
    'status';
    'ramShareArn';
    'updatedAt';
    'tearDownStartedAt';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "PrivateLinkCheckResultStatusEnum",
            "format": ""
        },
        {
            "name": "ramShareArn",
            "baseName": "ramShareArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "tearDownStartedAt",
            "baseName": "tearDownStartedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return PrivateLinkCheckResult.attributeTypeMap;
    }
    constructor() {
    }
}
export var PrivateLinkCheckResultStatusEnum;
(function (PrivateLinkCheckResultStatusEnum) {
    PrivateLinkCheckResultStatusEnum["NotSetup"] = "not_setup";
    PrivateLinkCheckResultStatusEnum["InProgress"] = "in_progress";
    PrivateLinkCheckResultStatusEnum["Active"] = "active";
    PrivateLinkCheckResultStatusEnum["TearingDown"] = "tearing_down";
})(PrivateLinkCheckResultStatusEnum || (PrivateLinkCheckResultStatusEnum = {}));
